module.exports = __webpack_public_path__ + "static/img/smartstation42.925fa2d9.png";